import { Navigate } from 'react-router-dom'
import { useCurrentUser } from '@/features/auth/state/auth'
import { ROUTES } from '@/config/routes'

const Protected = ({ children }: { children: JSX.Element }) => {
  const user = useCurrentUser()

  if (!user) {
    return <Navigate to={ROUTES.SIGNIN.path} />
  }

  return children
}

export default Protected
